/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect, useRef } from 'react'
import jsPDF from 'jspdf'
import DownloadIcon from 'assets/icons/DownloadIcon'
import DevelopmentPlanSchema from 'views/components/report/components/development-plan'
import { fetchFeedBack } from 'views/screens/Evaluated-User/services/fetch-development-plan-betesa'
import { useNotification } from 'lib/context/notification.context'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { DownloadContainer, TextDownload } from './styled'
import getDevelopmentPlan from 'services/pdfReports/getDevelopmentPlan'
import ModalLoader from 'views/components/UI/ModalLoader'
const DownloadPlanCard = ({ skillParam, typeTest, processIdParam, userName, setLoadingReport }: any) => {
  const { t } = useTranslation()
  const { getSuccess } = useNotification()
  const [data, setData] = useState<any>()
  const [loading, setLoading] = useState(false)
  const developmentPlanTemplateRef = useRef<HTMLDivElement>(null)

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [screenheight, setScreenHeight] = useState(window.innerHeight)

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
      setScreenHeight(window.innerHeight)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleDownload = async () => {
    try {
      setLoadingReport(true)
      const response = await getDevelopmentPlan(skillParam)

      const { url } = response

      window.open(url, '_blank')

      getSuccess(t('global.notifications.planGenerated'))
      setLoadingReport(false)
    } catch (error) {
      console.error('Error al descargar el plan de desarrollo:', error)
      setLoadingReport(false)
    }
  }

  if (loading) return <ModalLoader isLoading={loading} />

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <DownloadContainer>
          <DownloadIcon />
          <TextDownload onClick={handleDownload}>
            {screenWidth > 1360 ? 'Descargar plan de desarrollo' : 'Descargar plan de'}
          </TextDownload>
        </DownloadContainer>
        {screenWidth < 1361 && (
          <TextDownload style={{ margin: '-15px 0 0 -10px' }} onClick={handleDownload}>
            desarrollo
          </TextDownload>
        )}
      </div>

      {data && (
        <div style={{ visibility: 'hidden', width: '595px', alignSelf: 'center', position: 'absolute', zIndex: '-1' }}>
          <div ref={developmentPlanTemplateRef}>
            <DevelopmentPlanSchema developmentPlan={data} type={typeTest} processId={processIdParam} />
          </div>
        </div>
      )}
    </>
  )
}

export default DownloadPlanCard
